import { Controller } from "@hotwired/stimulus"

/**
 * Handles per-segment image regeneration on the story short preview step.
 * Supports optional custom image prompt via a prompt input.
 */
export default class extends Controller {
  static values = {
    url: String,
    index: Number
  }

  async regenerate(event) {
    const button = event.currentTarget

    // Prompt the user for an optional custom image description
    const customPrompt = prompt(
      "Optionally describe what this scene should look like.\n" +
      "Leave blank to auto-generate from the script.",
      ""
    )

    // User clicked Cancel
    if (customPrompt === null) return

    button.disabled = true
    const originalHTML = button.innerHTML
    button.innerHTML = `<svg class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>`

    try {
      const body = { segment_index: this.indexValue }
      if (customPrompt.trim()) {
        body.image_prompt = customPrompt.trim()
      }

      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content,
          "Accept": "application/json"
        },
        body: JSON.stringify(body)
      })

      const data = await response.json()

      if (response.ok && data.success) {
        window.location.reload()
      } else {
        alert(data.error || "Image regeneration failed")
        button.disabled = false
        button.innerHTML = originalHTML
      }
    } catch {
      alert("Network error. Please try again.")
      button.disabled = false
      button.innerHTML = originalHTML
    }
  }
}
